export const getMonitorTutorialSteps = ({ hasActiveRoutes = true } = {}) => {
  if (!hasActiveRoutes) {
    return [
          {
            target: '#monitor-global-header',
            title: 'Monitor en tiempo real',
            content:
              'Este módulo te muestra el estado general de las rutas activas. Acá ves rápido qué está en marcha y qué necesita atención.',
            narration:
              'Este módulo te muestra el estado general de las rutas activas. Acá ves rápido qué está en marcha y qué necesita atención.',
            audio: '/tutorials/monitor/01-monitor-global.mp3',
            placement: 'bottom',
            disableBeacon: true,
          },
          {
            target: '#monitor-global-empty',
            title: 'Primera activación del monitor',
            content:
              'Todavía no hay rutas activas para mostrar acá. Primero creá una unidad en Logística y después armá una ruta con al menos un destino.',
            narration:
              'Todavía no hay rutas activas para mostrar acá. Primero creá una unidad en Logística y después armá una ruta con al menos un destino.',
            audio: null,
            placement: 'top',
            disableBeacon: true,
          },
          {
            target: '#monitor-global-empty-actions',
            title: 'Cómo seguir',
            content:
              'Desde este acceso volvés a Logística para crear la unidad y preparar la primera ruta. Cuando haya una ruta activa, este monitor se completa solo.',
            narration:
              'Desde este acceso volvés a Logística para crear la unidad y preparar la primera ruta. Cuando haya una ruta activa, este monitor se completa solo.',
            audio: null,
            placement: 'top',
            disableBeacon: true,
          }
    ];
  }

  return [
        {
          target: '#monitor-global-header',
          title: 'Monitor en tiempo real',
          content:
            'Monitor en tiempo real te da una vista rápida de las rutas activas. Acá seguís unidades y recorridos sin entrar todavía al detalle.',
          narration:
            'Monitor en tiempo real te da una vista rápida de las rutas activas. Acá seguís unidades y recorridos sin entrar todavía al detalle.',
          audio: '/tutorials/monitor/01-monitor-global.mp3',
          placement: 'bottom',
          disableBeacon: true,
        },
        {
          target: '#monitor-global-kpis',
          title: 'Indicadores rápidos',
          content:
            'Estos indicadores te resumen el día en una mirada: cuántas rutas siguen activas, cuántas unidades reportan y cuáles necesitan revisión.',
          narration:
            'Estos indicadores te resumen el día en una mirada. Acá sabés cuántas rutas siguen activas, cuántas unidades reportan y cuáles necesitan revisión.',
          audio: '/tutorials/monitor/02-indicadores.mp3',
          placement: 'bottom',
          disableBeacon: true,
        },
        {
          target: '#monitor-global-map',
          title: 'Mapa de la operación',
          content:
            'En este mapa ves la base y las rutas activas para ubicar rápido cada recorrido.',
          narration:
            'En este mapa ves la base y las rutas activas para ubicar rápido cada recorrido.',
          audio: '/tutorials/monitor/03-mapa-operacion.mp3',
          placement: 'left',
          disableBeacon: true,
        },
        {
          target: '#monitor-global-list',
          title: 'Flota activa',
          content:
            'En esta columna seguís cada unidad o chofer en trabajo. Cada tarjeta resume estado, avance y acceso al detalle.',
          narration:
            'En esta columna seguís cada unidad o chofer en trabajo. Cada tarjeta resume estado, avance y acceso al detalle.',
          audio: '/tutorials/monitor/04-flota-activa.mp3',
          placement: 'left',
          disableBeacon: true,
        },
        {
          target: '#monitor-global-history-detail',
          title: 'Ver detalle',
          content:
            'Este acceso abre el detalle de la ruta seleccionada para revisar su recorrido, sus estados y su cierre.',
          narration:
            'Desde ver detalle abrís la ruta seleccionada para revisar su recorrido, sus estados y su cierre.',
          audio: '/tutorials/monitor/05-ver-detalle.mp3',
          placement: 'left',
          disableBeacon: true,
        },
        {
          target: '#monitor-global-route-sheet-toggle',
          title: 'Hoja de ruta',
          content:
            'Desde hoja de ruta abrís los destinos de ese recorrido. Así pasás del panorama general al trabajo real de esa ruta.',
          narration:
            'Desde hoja de ruta abrís los destinos de ese recorrido. Así pasás del panorama general al trabajo real de esa ruta.',
          audio: '/tutorials/monitor/06-hoja-de-ruta.mp3',
          placement: 'left',
          disableBeacon: true,
        },
        {
          target: '#monitor-global-route-sheet',
          title: 'Destinos de la hoja',
          content:
            'Acá ves los destinos cargados para esa ruta, en orden y con su estado actual.',
          narration:
            'Acá ves los destinos cargados para esa ruta, en orden y con su estado actual.',
          audio: '/tutorials/monitor/07-destinos-hoja.mp3',
          placement: 'left',
          disableBeacon: true,
        },
        {
          target: '#monitor-global-open-individual',
          title: 'Ir al monitor individual',
          content:
            'Desde acá abrís el monitor individual de esa ruta para seguir un solo viaje en detalle.',
          narration:
            'Desde acá abrís el monitor individual de esa ruta para seguir un solo viaje en detalle.',
          audio: '/tutorials/monitor/08-monitor-individual.mp3',
          placement: 'left',
          disableBeacon: true,
        },
  ];
};

export default getMonitorTutorialSteps;
